<template>
  <v-row class="pa-2">
    <!-- Projects KPI Section -->
    <v-col cols="12">
      <v-card outlined elevation="0" class="pa-4 rounded-lg white">
        <div class="d-flex align-center mb-3">
          <v-icon color="cyan darken-3" class="mr-2"
            >mdi-briefcase-outline</v-icon
          >
          <span
            class="font-weight-700 color-custom-blue font-size-18 text-uppercase"
          >
            Project Overview
          </span>
        </div>
        <v-row class="flex-nowrap-md">
          <v-col
            v-for="(item, index) in dProjectArr"
            :key="index"
            cols="12"
            sm="6"
            md=""
            class="flex-grow-1"
          >
            <v-card
              outlined
              elevation="0"
              :color="`${item.color} lighten-5`"
              :style="`border-color: ${getBgColor(item.color)} !important`"
              class="pa-3 h-100 rounded-lg"
            >
              <div class="d-flex align-center justify-space-between mb-2">
                <span class="font-weight-600 font-size-14 color-custom-blue">
                  {{ item.title }}
                </span>
                <v-chip
                  x-small
                  dark
                  :color="item.iconColor"
                  class="font-weight-700 px-2"
                >
                  {{ item.value }}
                </v-chip>
              </div>
              <div class="d-flex align-center justify-space-between mt-1">
                <span :class="`font-size-22 font-weight-700 ${item.textColor}`">
                  {{ formatMoney(item.amount) }}
                </span>
                <v-icon size="32" :color="item.iconColor">
                  {{ item.icon }}
                </v-icon>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-col>

    <!-- Milestones KPI Section -->
    <v-col cols="12">
      <v-card outlined elevation="0" class="pa-4 rounded-lg white">
        <div class="d-flex align-center mb-3">
          <v-icon color="cyan darken-3" class="mr-2">mdi-flag-checkered</v-icon>
          <span
            class="font-weight-700 color-custom-blue font-size-18 text-uppercase"
          >
            Milestones Summary
          </span>
        </div>
        <v-row class="flex-nowrap-md">
          <v-col
            v-for="(item, index) in dProjectMilestoneArr"
            :key="index"
            cols="12"
            sm="6"
            md=""
            class="flex-grow-1"
          >
            <v-card
              outlined
              elevation="0"
              :color="`${item.color} lighten-5`"
              :style="`border-color: ${getBgColor(item.color)} !important`"
              class="pa-3 h-100 rounded-lg"
            >
              <div class="d-flex align-center justify-space-between mb-2">
                <span class="font-weight-600 font-size-14 color-custom-blue">
                  {{ item.title }}
                </span>
                <v-chip
                  x-small
                  dark
                  :color="item.iconColor"
                  class="font-weight-700 px-2"
                >
                  {{ item.value }}
                </v-chip>
              </div>
              <div class="d-flex align-center justify-space-between mt-1">
                <span :class="`font-size-22 font-weight-700 ${item.textColor}`">
                  {{ formatMoney(item.amount) }}
                </span>
                <v-icon size="32" :color="item.iconColor">
                  {{ item.icon }}
                </v-icon>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-col>

    <!-- Project Budget Chart Section -->
    <v-col cols="12">
      <v-card outlined elevation="0" class="pa-4 rounded-lg white">
        <div class="d-flex align-center justify-space-between mb-4">
          <div class="d-flex align-center">
            <v-icon color="cyan darken-3" class="mr-2">mdi-chart-bar</v-icon>
            <span
              class="font-weight-700 color-custom-blue font-size-18 text-uppercase"
            >
              Project Budget Breakdown
            </span>
          </div>
          <v-btn
            depressed
            small
            :to="{ name: 'admin.project' }"
            color="cyan"
            class="white--text font-weight-600 custom-bold-button"
          >
            View All Projects
          </v-btn>
        </div>

        <div id="chart" class="budget">
          <apexchart
            type="bar"
            height="350"
            :options="budgetchartOptions"
            :series="budgetseries"
          ></apexchart>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";
import CommonFunctionMixin from "@/core/lib/common/common.functions.mixin";
import { GET } from "@/core/services/store/request.module";

/* import { filter } from "lodash"; */
/* import moment from "moment"; */
export default {
  name: "ProjectStatus",
  mixins: [CommonFunctionMixin],

  data() {
    return {
      categories: [],
      // Project Budget chart Start data
      budgetseries: [],
      /*   budgetchartOptions: {
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            show: false,
          },
        },
        colors: ["#008ffb", "#00e396"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 5,
            borderRadiusApplication: "end",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },

        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },

        yaxis: {
          title: {
            text: "$ (thousands)",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "$ " + val + " thousands";
            },
          },
        },
      }, */
      // Project Budget chart End data

      projectDurationFilterList: [
        { text: "This Week", value: "this_week" },
        { text: "This Month", value: "this_month" },
        { text: "This Quarter", value: "this_quarter" },
        { text: "This Year", value: "this_year" },
      ],
      projectTypeFilterList: [
        { text: "All Type", value: "all" },
        { text: "Software", value: "software" },
        { text: "Seo", value: "seo" },
      ],
    };
  },
  methods: {
    async getProjectCount() {
      this.pageLoading = true;
      try {
        const response = await this.$store.dispatch(GET, {
          url: "project-graph",
        });

        if (response.data) {
          this.updateChart(
            response.data.data,
            response.data.yAxisTitle,
            response.data.budgetSeries
          );
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    },
    updateChart(data, yAxisTitle, budgetSeries) {
      this.categories = data.map((item) => [
        item.project_code,
        item.project_title,
      ]);
      this.budgetseries = budgetSeries;
      this.yAxisTitle = yAxisTitle; // Update Y-Axis title dynamically
    },
    getBgColor(color) {
      switch (color) {
        case "cyan":
          return "#00bcd4";
        case "green":
          return "#4CAF50";
        case "red":
          return "#F44336";
        case "blue":
          return "#2196f3";
        case "orange":
          return "#ff9800";
        case "purple":
          return "#9c27b0";
        case "yellow":
          return "#ffeb3b";
        default:
          return "white";
      }
    },
  },
  mounted() {
    this.getProjectCount();
  },
  computed: {
    ...mapGetters([
      "dbEngineers",
      "dProjectArr",
      "dActiveProjectDuration",
      "dActiveProjectType",
      "dActiveProjectUser",
      "dProjectMilestoneArr",
    ]),
    budgetchartOptions() {
      return {
        chart: {
          type: "bar",
          height: 350,
          toolbar: { show: false },
        },
        colors: ["#008ffb", "#00e396"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 5,
            borderRadiusApplication: "end",
          },
        },
        dataLabels: { enabled: false },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: this.categories, // Dynamic categories from API
          labels: {
            trim: true,
            style: { fontSize: "12px" },
          },
        },
        yaxis: {
          title: {
            text: this.yAxisTitle, // Dynamically update Y-Axis title
          },
        },
        fill: { opacity: 1 },
        tooltip: {
          y: {
            formatter: (val) => this.formatMoney(val),
          },
        },
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.project-stats-count {
  tr:not(.no-border) {
    th,
    td {
      padding: 4px 8px;
      // border:1px solid grey
    }
  }
}
.right-graphics {
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 100px;
  opacity: 0.3;
}
</style>
